var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagLiechtenstein(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0.695625 16 16 13.9131 16 13.9131L32 16Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.1635 7.1635 0 16 0C24.8365 0 32 7.1635 32 16",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8263 11.1305C11.8263 9.97799 10.892 9.04361 9.73939 9.04361C9.2047 9.04361 8.71739 9.24486 8.34808 9.57542V8.34792H9.0437V6.95661H8.34808V6.26099H6.95677V6.95661H6.26114V8.34792H6.95677V9.57542C6.58745 9.24486 6.10014 9.04361 5.56545 9.04361C4.41289 9.04361 3.47852 9.97799 3.47852 11.1305C3.47852 11.7485 3.74733 12.3035 4.17414 12.6857V13.9132H11.1306V12.6857C11.5576 12.3035 11.8263 11.7485 11.8263 11.1305Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagLiechtenstein);
export default __webpack_public_path__ + "static/media/flag_liechtenstein.8a53dab5629c6aa8ae847e813625860d.svg";
export { ForwardRef as ReactComponent };